module.exports = __webpack_public_path__ + "img/1698372586491-nib rudiyono.jpg.39b9713f.webp";